module.exports = __webpack_public_path__ + "img/s2.c3bff98d.png";